import { useCustom } from "@refinedev/core";

type QontoConnectionStatus = {
  connected?: boolean;
};

type InvoiceSettings = {
  paymentEngine?: "stripe" | "qonto";
  invoicingEngine?: "internal" | "qonto";
};

export function useQontoActive(): boolean {
  const { data: invoiceSettingsResponse } = useCustom<InvoiceSettings>({
    url: "invoice-settings",
    method: "get",
    queryOptions: {
      retry: false,
      staleTime: 60_000,
    },
  });

  const { data: qontoStatusResponse } = useCustom<QontoConnectionStatus>({
    url: "integrations/qonto",
    method: "get",
    queryOptions: {
      retry: false,
      staleTime: 60_000,
    },
  });

  const qontoConnected = qontoStatusResponse?.data?.connected === true;
  const paymentEngine = invoiceSettingsResponse?.data?.paymentEngine ?? "stripe";
  const invoicingEngine =
    invoiceSettingsResponse?.data?.invoicingEngine ?? "internal";

  return (
    qontoConnected &&
    (paymentEngine === "qonto" || invoicingEngine === "qonto")
  );
}
